import React from 'react';
import InputField from '../../../../../component/form/FormInput';

const OtherDetails = ({ data, setData, error, setError, disabled }) => {
	const handleOtherDetailsInputChange = (key, value) => {
		setData((prev) => ({
			...prev,
			othersDetails: {
				...prev.othersDetails,
				[key]: value,
			},
		}));
		var errorData = { ...error };
		if (key === 'registration_number' && (value === '' || value === undefined || value === null)) {
			errorData[key] =
				'Please enter registration number (As Per State Medical Council) in the field';
		} else {
			delete errorData[key];
		}
		setError(errorData);
	};

	return (
		<div>
			<div className="row">
				<div className="col-6">
					<InputField
						label="Registration Number (As Per State Medical Council)"
						placeholder="Registration Number"
						value={data.registration_number}
						onChange={(value) => handleOtherDetailsInputChange('registration_number', value)}
						type="text"
						autoComplete="off"
						disabled={disabled}
						required={true}
						error={error?.registration_number}
					/>
				</div>
			</div>
			<div className="col-2">
				<div style={{ marginBottom: '10px', marginTop: '10px', color: '#000000' }}>
					<span> Enable Portal</span>
					<label style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '15px' }}>
						<input
							type="checkbox"
							checked={data.is_enable_portal}
							style={{ width: '20px', height: '20px' }}
							onChange={(e) => {
								handleOtherDetailsInputChange('is_enable_portal', e.target.checked);
							}}
							disabled={disabled}
						/>
						Enable Portal
					</label>
				</div>
			</div>
		</div>
	);
};

export default OtherDetails;
